<template>
  <div
    v-if="!link"
    :class="classes"
  >
    <slot />
    <picture>
      <source
        media="(max-width: 480px)"
        :srcset="imageMobile"
      >
      <source
        media="(min-width: 481px) and (max-width: 1024px)"
        :srcset="imageTablet"
      >
      <img
        :src="imageDesktop"
        class="c-image__item image"
        :alt="alt"
        :style="styles"
      >
    </picture>
  </div>

  <a
    v-else
    :class="classes"
    class="c-image-link"
    :href="link"
    @click="pushGTM"
  >
    <slot />
    <picture class="c-image-link__pictureContainer">
      <source
        media="(max-width: 480px)"
        :srcset="imageMobile"
      >
      <source
        media="(min-width: 481px) and (max-width: 1024px)"
        :srcset="imageTablet"
      >
      <img
        :src="imageDesktop"
        class="c-image__item image c-image-link__picture"
        :alt="alt"
        :style="styles"
      >
    </picture>
    <c-text
      :color="textColor"
      :size="textSize"
      :weight="textWeight"
      :align="textAlign"
      class="c-image__text"
    >
      <slot name="text" />
    </c-text>
  </a>
</template>

<script>
import CText from '@atoms/text/text.vue'
import isOutbound from '@tagging/isOutbound.js'

export default {
  name: 'c-image',
  components: {
    CText,
  },
  props: {
    alt: {
      type: String,
      default: ''
    },
    background: {
      type: Boolean,
      default: false
    },
    imageMobile: {
      type: String,
      default: ''
    },
    imageTablet: {
      type: String,
      default: ''
    },
    imageDesktop: {
      type: String,
      default: ''
    },
    maxSize: {
      type: String,
      default: null
    },
    link: {
      type: String,
    },
    textColor: {
      type: String,
      default: '#43515A'
    },
    textSize: {
      type: String,
      default: 'xs'
    },
    textWeight: {
      type: String,
      default: '400'
    },
    textAlign: {
      type: String,
      default: 'left'
    }
  },
  computed: {
    classes() {
      return [
        'c-image',
        [this.background ? 'c-image--background' : 'c-image--block']
      ]
    },
    styles() {
      return {
        'max-width': `${this.maxSize}px`
      }
    }
  },
  methods: {
    pushGTM(event) {
      const target = event.target.closest('a')
      const title = target.parentElement.parentElement.innerText

      window.dataLayer.push({
        event: 'click',
        section: title || 'vazio',
        label: target.innerText || '',
        outbound: isOutbound(target)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .c-image {
    $container: &;
    position: relative;
    width: 100%;
    height: auto;
    object-fit: cover;
    text-decoration: none;

    & > div {
      width: 100%;
      height: 100%;
    }

    &--block {
      #{$container}__item {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
      }
    }

    &--background {
      height: 100%;

      #{$container}__item {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
      }
    }

    &__text {
      margin-top: 0.5rem;
    }
  }

  .c-image-link {
    &__pictureContainer {
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    &__picture {
      transition: all 0.8s;

      &:hover {
        transform: scale(1.08);
      }
    }
  }
</style>
